'use strict';

var React = require('react');

var SvgIllustrationMajor = function SvgIllustrationMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.155 3.844a2.079 2.079 0 0 0-2.831-.1l-6.354 5.506a3.75 3.75 0 0 0-3.72 3.75v3c0 .414.336.75.75.75h3a3.75 3.75 0 0 0 3.75-3.72l5.506-6.354a2.08 2.08 0 0 0-.1-2.832Zm-5.841 7.399 4.809-5.55a.579.579 0 0 0-.817-.816l-5.549 4.81a3.768 3.768 0 0 1 1.557 1.556Zm-3.314-.493a2.25 2.25 0 0 1 0 4.5h-2.25v-2.25a2.25 2.25 0 0 1 2.25-2.25Z"
  }));
};
SvgIllustrationMajor.displayName = "IllustrationMajor";

exports.SvgIllustrationMajor = SvgIllustrationMajor;
